export default "__VITE_ASSET__0bf9240b__"